<div class="modal-header" id="confirmation-reason-missing-protocol">
    <h3 class="modal-title" id="modal-title" translate="CONFIRMATION_SUMMARY_FORM_WARN_F4M_TITLE"></h3>
    <span class="close" (click)="closeModal()">&times;</span>
</div>
<div class="modal-body" id="modal-body">
    <form [formGroup]="documentReasonForm">
        <fieldset formArrayName="formChildren">
            <div class="row">
                <div class="col-12" translate="CONFIRMATION_SUMMARY_FORM_F4M_WARN_MISSING_PROTOCOLS"></div>
                @if (model.reasonForMissingProtocols) {
                    <div
                        class="col-12 fw-bold mt-3"
                        translate="CONFIRMATION_SUMMARY_FORM_F4M_WARN_MISSING_PROTOCOLS_EXTENDED"
                    ></div>
                }
            </div>
            @if (model.reasonForMissingProtocols) {
                <div class="row my-3">
                    <div class="col-12">
                        <pace-core-dropdown
                            [(model)]="model.reasonForMissingProtocols"
                            [parentForm]="formChildren"
                            (valueChange)="model.onReasonSelected()"
                        ></pace-core-dropdown>
                    </div>
                </div>
            }
            @if (model.displayOtherReasonTextField) {
                <div class="row mb-3">
                    <div class="col-12">
                        <pace-core-text-input
                            [(model)]="model.otherReasonDescription"
                            [parentForm]="formChildren"
                        ></pace-core-text-input>
                    </div>
                </div>
            }
        </fieldset>
    </form>
</div>
<div class="modal-footer">
    <button class="btn btn-secondary me-1" (click)="onNavigateToPaceForms()">
        {{ strings.paceFormsQuickAccessLabel }}
    </button>
    @if (model.reasonForMissingProtocols?.value?.length) {
        <button class="btn btn-primary" [disabled]="documentReasonForm.invalid" (click)="applyDocumentedReason()">
            {{ strings.applyLabel }}
        </button>
    }
</div>
